import { CurrentUser, GetUserData } from "common/service/CommonService";
import { APIClient } from "../../../../api/api_helper";
import { AMBULATORY_VISIT_ACTIVITY_RESULT_API, AMBULATORY_VISIT_API, AMBULATORY_VISIT_SUBJECT_DECISION_API } from "../../../../api/url_helper";
import { DROPOUT_TYPE_OPTIONS } from "api/modules/common.option";

const api = new APIClient();

export const ambulatoryVisitApiService = {

  selectallAmbulatoryVisit: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_API + "SelectAll", data);
  },

  selectdataAmbulatoryVisit: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_API + "Select", data);
  },

  assignSubjects: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitSubjectAssignment/Insert", data);
  },

  selectAllAssignedSubjects: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitSubjectAssignment/SelectAll", data);
  },

  selectAllEligibleSubjects: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitEligibleSubjects/SelectAll", data);
  },

  insertAmbulatoryVisitStatusHistory: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitStatusHistory/Insert", data);
  },

  checkInSubject: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitSubject/CheckIn", data);
  },

  checkOutSubject: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitSubject/CheckOut", data);
  },

  updateSubjectDecision: (payload: any) => {
    const { subject, formValues, comments, studyid, subjectId } = payload;
    const userData = GetUserData() as any;
    const visitsubjectassignmentid = Number(subject.visitsubjectassignmentid || subject.id || 0);
    const createdby = Number(userData?.userid || 1);
    const volunteerid = Number(subject.volunteerid || subject.volunteerId || 0);
    const subjectno = subject.subjectno || subject.subjectId || subjectId;
    const currentStatus = (formValues.status || "").toLowerCase();

    const requestData: any = {
      visitsubjectassignmentid,
      createdby,
      decisionstatus : currentStatus,
      decisionremarks: comments || "",
      volunteerid,
      studyid,
      subjectno,
    };

    if (currentStatus === "dropped") {
      const selectedType = DROPOUT_TYPE_OPTIONS.find(
        (opt) => String(opt.value) === String(formValues.dropouttype) || opt.label === formValues.dropouttype
      )?.label || (formValues.dropouttype ? String(formValues.dropouttype) : null);
      const isAE = selectedType === "Medical / AE";

      Object.assign(requestData, {
        dropouttype     : formValues.dropouttype,
        dropoutdate     : formValues.dropoutdate,
        studystage      : formValues.studystage,
        effectivedate   : formValues.effectivedate,
        dropoutreason   : formValues.dropoutreason,
        detailedreason  : formValues.detailedreason,
        ...(isAE ? { aereferenceno: formValues.aereferenceno } : {}),
      });
    } else if (currentStatus === "blocked") {
      const isPermanent = formValues.blocktype === "Permanent";
      Object.assign(requestData, {
        blocktype              : formValues.blocktype,
        blockreason           : formValues.blockreason,
        blocksource           : "ambulatory-visit",
        startdate             : formValues.blockstartdate,
        detailedremarks       : formValues.detailedremarks || comments || "",
        ...(!isPermanent ? {
          enddate               : formValues.blockenddate,
          blockduration         : formValues.blockduration,
          rescreeningeligibility: formValues.rescreeningeligibility,
        } : {}),
      });
    }

    return api.create(AMBULATORY_VISIT_SUBJECT_DECISION_API.UPDATE, requestData);
  },

  selectdataAmbulatoryVisitActivityResult: (data: any) => {
    return api.create(AMBULATORY_VISIT_ACTIVITY_RESULT_API.AMBULATORY_VISIT_ACTIVITY_RESULT_API + "Select", data);
  },

  updateSubjectCRFResult: (data: any) => {
    const userData = GetUserData() as any;
    const payload = {
      updatedby: Number(userData?.userid),
      updatereason: "CRF Filled successfully",
      ...data,
    };
    return api.create(AMBULATORY_VISIT_ACTIVITY_RESULT_API.AMBULATORY_VISIT_SUBJECT_ASSIGNMENT_RESULT + "Update", payload);
  },

  insertAmbulatoryVisitSubjectAssessment: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl")+ "AmbulatoryVisitSubjectAssessment/Insert", data);
  },

  selectAmbulatoryVisitSubjectAssessment: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl")+ "AmbulatoryVisitSubjectAssessment/Select", data);
  },

  insertAmbulatoryVisitSubjectBloodCollection: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitSubjectBloodCollection/Insert", data);
  },

  selectAmbulatoryVisitSubjectBloodCollection: (data: any) => {
    return api.create(sessionStorage.getItem("baseUrl") + "AmbulatoryVisitSubjectBloodCollection/Select", data);
  },
};
